// extracted by mini-css-extract-plugin
var _1 = "cooking-Hqq_L";
var _2 = "description-oWoF9";
var _3 = "details-L9MSw";
var _4 = "info-JlNCZ";
var _5 = "link-eafbH";
var _6 = "options-E7eXD";
var _7 = "person-x_KxG";
var _8 = "recipe-lp8u1";
var _9 = "title-hAqJm";
var _a = "wrapper-mZ3T9";
export { _1 as "cooking", _2 as "description", _3 as "details", _4 as "info", _5 as "link", _6 as "options", _7 as "person", _8 as "recipe", _9 as "title", _a as "wrapper" }
